/**
 * UrnWorth product form override.
 *
 * Dawn's own <product-form> element only ever adds a single variant to the
 * cart. When a customization field (see snippets/urnworth-engraving-fields.liquid)
 * is filled in, this intercepts the submit in the CAPTURE phase (before
 * Dawn's own bubble-phase handler runs), bundles the main product AND its
 * linked fee product(s) into one /cart/add.js request, then reuses Dawn's
 * own cart-drawer refresh mechanism.
 *
 * Four field types are supported, each checked differently:
 *   - checkbox (.uw-fee-checkbox): fee applies only if checked
 *   - textarea (.uw-fee-textarea): fee applies only if non-empty
 *   - hidden input (.uw-fee-trigger): fee applies only if non-empty — used by
 *     the photo-upload addon, where the trigger value is a Cloudinary URL
 *     written in after a successful upload, not something the customer types
 *   - select (.uw-fee-select): the fee variant lives on the SELECTED
 *     OPTION's data-fee-variant, not on the select itself, since only
 *     some options (e.g. a longer chain length) carry an upcharge
 *
 * If nothing on the form has an active fee, this does nothing and Dawn's
 * default single-item flow runs exactly as normal.
 */
(function () {
  // Returns the fee variant id that should be charged for this element right
  // now, or null if this element currently has no fee active.
  function activeFeeVariant(el) {
    if (el.tagName === 'SELECT' && el.classList.contains('uw-fee-select')) {
      var selected = el.options[el.selectedIndex];
      return selected && selected.dataset.feeVariant ? selected.dataset.feeVariant : null;
    }
    if (!el.dataset.feeVariant) return null;
    if (el.type === 'checkbox') {
      return el.checked ? el.dataset.feeVariant : null;
    }
    return el.value && el.value.trim() !== '' ? el.dataset.feeVariant : null;
  }

  function initUrnworthProductForm(form) {
    if (form.dataset.uwBound) return;
    form.dataset.uwBound = 'true';

    form.addEventListener(
      'submit',
      function (e) {
        var feeInputs = form.querySelectorAll(
          'input.uw-fee-checkbox[data-fee-variant], textarea.uw-fee-textarea[data-fee-variant], input.uw-fee-trigger[data-fee-variant], select.uw-fee-select'
        );

        var activeFees = [];
        feeInputs.forEach(function (el) {
          var variant = activeFeeVariant(el);
          if (variant) activeFees.push(variant);
        });

        if (!activeFees.length) return; // let Dawn's default add-to-cart flow handle it

        e.preventDefault();
        e.stopImmediatePropagation();

        var submitBtn = form.querySelector('[type="submit"]');
        var btnSpan = submitBtn ? submitBtn.querySelector('span') : null;
        if (submitBtn) submitBtn.setAttribute('aria-disabled', 'true');
        if (btnSpan) btnSpan.textContent = 'Adding...';

        var variantIdField = form.querySelector('.product-variant-id');
        var variantId = variantIdField ? parseInt(variantIdField.value, 10) : null;
        var quantityEl = form.querySelector('[name="quantity"]');
        var quantity = quantityEl ? parseInt(quantityEl.value, 10) || 1 : 1;

        var properties = {};
        form.querySelectorAll('[name^="properties["]').forEach(function (el) {
          var key = el.name.replace('properties[', '').replace(']', '');
          if (el.type === 'checkbox') {
            if (el.checked) properties[key] = el.value;
          } else if (el.value && el.value.trim() !== '') {
            properties[key] = el.value;
          }
        });

        var feeItems = activeFees.map(function (variantId) {
          return { id: parseInt(variantId, 10), quantity: 1, properties: {} };
        });

        // Main product first, fee item(s) immediately after — urnworth-cart-sync.js
        // relies on this exact ordering to know which fee belongs to which product.
        var items = [{ id: variantId, quantity: quantity, properties: properties }].concat(feeItems);

        var cartDrawer = document.querySelector('cart-drawer');
        var body = { items: items };
        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          body.sections = cartDrawer.getSectionsToRender().map(function (s) {
            return s.id;
          });
          body.sections_url = window.location.pathname;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        })
          .then(function (res) {
            return res.json();
          })
          .then(function (data) {
            if (submitBtn) submitBtn.removeAttribute('aria-disabled');
            if (btnSpan) btnSpan.textContent = 'Add to cart';

            if (data.status) {
              alert('Error: ' + (data.description || data.message || 'Could not add to cart'));
              return;
            }

            if (cartDrawer && typeof cartDrawer.renderContents === 'function' && data.sections) {
              cartDrawer.renderContents(data);
            } else {
              window.location.href = '/cart';
            }
          })
          .catch(function (err) {
            console.error('UrnWorth add-to-cart error:', err);
            if (submitBtn) submitBtn.removeAttribute('aria-disabled');
            if (btnSpan) btnSpan.textContent = 'Add to cart';
          });
      },
      true // capture phase: run before Dawn's own bubble-phase submit handler
    );
  }

  function init() {
    document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(initUrnworthProductForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
